export function log(arg = '', { id = 'app', ts = true, type = 'log' } = {}) {
  const timestamp = type !== 'error' && ts ? new Date().getTime() : 0;

  if (timestamp > 0) {
    console[type](arg instanceof Object ? arg : `[${id}:${timestamp}] ${arg}`);
  } else {
    console[type](arg);
  }
}
